import { WEEKDAYS } from '@/enums/week-days.enum.js'
class FormOpenHoursManager {
  constructor (openHours) {
    this.openHours = openHours
    this.weekdays = Object.values(WEEKDAYS)
  }

  getField (defaultValues) {
    const values = this.weekdays.reduce(
      (acc, weekday) => ({
        ...acc,
        // ex: Monday => monday
        [weekday?.toLowerCase()]: {
          start: this.openHours?.[weekday]?.start,
          end: this.openHours?.[weekday]?.end
        }
      }),
      {}
    )

    return {
      ...defaultValues,
      initialValues: values
    }
  }
}

export default FormOpenHoursManager
